import * as React from 'react';

import { BillStatus, enumBillStatus } from '@rematter/frontend-lib-api-client';
import { Badge } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';
import { colorByBillStatus } from '../../utils';

type Props = {
  status: BillStatus;
};

//
// ⚛️ ⚛️ ⚛️ BILL STATUS BADGE ⚛️ ⚛️ ⚛️
//
export const BillStatusBadge: React.FC<Props> = ({ status }) => {
  // Translations
  const t = useTranslations();

  const color = colorByBillStatus[status];

  // Memoized values
  const label = React.useMemo(() => {
    switch (status) {
      case enumBillStatus.Pending:
        return t.bills.list.status.badge.pending;
      case enumBillStatus.Paid:
        return t.bills.list.status.badge.paid;
      case enumBillStatus.Voided:
        return t.bills.list.status.badge.voided;
    }
  }, [
    status,
    t.bills.list.status.badge.pending,
    t.bills.list.status.badge.paid,
    t.bills.list.status.badge.voided,
  ]);

  return (
    <Badge color={color} className="@BillStatusBadge">
      {label}
    </Badge>
  );
};
